(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-campaign-bar"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bf-campaign-bar')) {
    customElements.define('bf-campaign-bar', class extends HTMLElement {
      connectedCallback() {
        const update = () => {
          const now = Date.now();
          const start = Date.parse(this.dataset.start);
          const end = Date.parse(this.dataset.end);
          if (!Number.isFinite(start) || !Number.isFinite(end) || end <= start) return;
          const before = now < start;
          const expired = now >= end;
          this.querySelector('[data-label]').textContent = expired ? this.dataset.after : '';
          const seconds = Math.max(0, Math.ceil(((before ? start : end) - now) / 1000));
          const minutes = Math.floor(seconds / 60);
          const days = Math.floor(minutes / 1440);
          const hours = Math.floor(minutes % 1440 / 60);
          this.querySelector('[data-time]').textContent = expired ? '' : `${days > 0 ? days + this.dataset.days + ' ' : ''}${String(hours).padStart(2, '0')}${this.dataset.hours} ${String(minutes % 60).padStart(2, '0')}${this.dataset.minutes} ${String(seconds % 60).padStart(2, '0')}s`;
        };
        update();
        this.timer = setInterval(update, 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();
})();
